var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "bg-container"
  }), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "digit-bg"
  }), _vm._m(0), _c('div', {
    staticClass: "row w-mb-24"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('r-button', {
    attrs: {
      "color": "rocky",
      "width": "wide",
      "title": _vm.btnName
    },
    on: {
      "click": function ($event) {
        return _vm.redirect();
      }
    }
  })], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row w-mb-24 w-row-16"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', {
    staticClass: "typo-h-28-32 text-titanic text-center"
  }, [_vm._v(" Запрашиваемая страница не найдена ")])])]);
}]

export { render, staticRenderFns }